// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"9c26816c","196":"f7afaac0","237":"1d386ec2","264":"fae7b89f","344":"0ee9018f","756":"bf0390db","902":"47b9909e"}[chunkId] + ".chunk.js";
};